import React from "react";
import "./Keyoffering.css";
import image1 from './images/Picture1.jpg'
import image2 from './images/Picture2.jpg'
import image3 from './images/Picture3.jpg'
import image4 from './images/Picture4.jpg'
import image5 from './images/Picture5.jpg'


const images = [
  { id: 1, src: image1, alt: "Pipeline Distribution Network" },
  { id: 2, src: image2, alt: "KT Weir Construction" },
  { id: 3, src: image3, alt: "Canals & Structures" },
  { id: 4, src: image4, alt: "Protection Wall" },
  { id: 5, src: image5, alt: "CADWM Work" },
];

const Keyoffering = () => {
  return (
    <div className="keyoffer-container">
      <header className="keyoffer-header">
        <h1>Our Achievements in Irrigation Projects</h1>
        <p>
          We have successfully completed design and construction of quality 
           Pipeline Distribution Networks, KT Weirs, Canals & Structures, 
          Protection Walls, CADWM work  etc. for the irrigation department 
          within the stipulated time period without any extension.
          <br /><br />
          Pipe Distribution networks completed having BWSG, PCCP and HDPE 
          pipes up to 150 km without any extension. Pipe Diameters vary 
          from 63mm to 1200mm.
        </p>
      </header>

      <div className="keyoffer-grid">
        {images.map((img) => (
          <div key={img.id} className="keyoffer-item">
            <img src={img.src} alt={img.alt} />
            <div className="overlay">
              <p>{img.alt}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Keyoffering;
